import { useEffect, useState } from "react";
import { CreditReturnDetailsViewModel } from "../../viewmodels/creditReturns/CreditReturnDetailsViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import {
  withRouter,
  isReadOnlyUser,
  cycleCountStatusOptions,
  convertToCurrencyFormat,
} from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import { Link, useParams } from "react-router-dom";
import CreditReturnCartonsTable from "./CreditReturnCartonsTable";
import Input from "../../components/controls/Input";
import ButtonDropdown from "../../components/controls/ButtonDropdown";
import OrderNotesModal from "../../components/forms/orders/OrderNotesModal";
import SelectMenu from "../../components/controls/SelectMenu";
import AuditActionLink from "../../components/audit/AuditActionLink";
import { getAuditApiEntityType } from "../../components/audit/auditEntityConfig";

function OrderDetails(props) {
  const { addSnackbar, logout } = props;

  const { creditReturnId } = useParams();

  const {
    creditReturn,
    loading,
    emptyModal,
    setEmptyModelOpen,
    setCreditReturn,
    getCreditReturnDetails,
    onUpdateCreditNote,
    askDeleteCarton,
    getCustomersForDropdown,
    customers,
    onSaveCr,
    printCr,
    askDeleteCr,
  } = CreditReturnDetailsViewModel(logout, creditReturnId, addSnackbar);

  useEffect(() => {
    getCreditReturnDetails();
    getCustomersForDropdown();
  }, []);

  const buttonOptions = [
    {
      name: "Print CR",
      onClick: printCr,
      inProgress: false,
    },
  ];
  const isReadOnly = isReadOnlyUser();
  const isClosed = creditReturn.status === 1;

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:items-center">
          <div className="sm:flex-auto flex items-center">
            <h1 className="text-xl font-semibold leading-6 text-gray-900">
              CR: {creditReturn.name}
            </h1>
            {creditReturnId ? (
              <AuditActionLink
                slug="credit-return"
                id={creditReturnId}
                name={creditReturn.name}
              />
            ) : null}
          </div>
          {loading ? (
            <div>
              <div className="border h-10 shadow rounded-md p-4 w-full mx-auto">
                <div className="animate-pulse flex space-x-4">Loading</div>
              </div>
            </div>
          ) : (
            <div className="mt-5 grid grid-cols-3 gap-3 h-full">
              <div className="col-span-2">
                <div className="card-custom p-2">
                  <CreditReturnCartonsTable
                    askDeleteCarton={askDeleteCarton}
                    closed={isClosed}
                    values={creditReturn}
                  />
                </div>
                <div className="flex justify-end p-4 gap-4">
                  {creditReturn ? (
                    <>
                      <p>
                        Total price:{" "}
                        <span className="font-bold">
                          {convertToCurrencyFormat(
                            creditReturn.total_dollar_amount ??
                              creditReturn.total_price,
                          )}
                        </span>
                      </p>
                    </>
                  ) : null}
                </div>
              </div>

              <div className="col-span-1 space-y-5">
                <div className="card-custom p-3 space-y-2">
                  <Input
                    label="Created By"
                    name="created_by"
                    value={creditReturn.created_by_name}
                    labelOn={true}
                    type="text"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    disabled={true}
                  />

                  <SelectMenu
                    handleInputChange={(e) =>
                      setCreditReturn({
                        ...creditReturn,
                        customer: e.target.value,
                      })
                    }
                    name="customer"
                    options={customers}
                    value={creditReturn.customer}
                    title={"Customer"}
                    showLabel={true}
                    disabled={isClosed}
                  />

                  <SelectMenu
                    handleInputChange={(e) =>
                      setCreditReturn({
                        ...creditReturn,
                        status: e.target.value.value,
                      })
                    }
                    name="status"
                    options={cycleCountStatusOptions}
                    value={cycleCountStatusOptions.find(
                      (o) => o.value === creditReturn.status
                    )}
                    title="Status"
                    showLabel={true}
                    disabled={isReadOnly}
                  />

                  <Input
                    label="CR #"
                    name="credit_return_number"
                    value={creditReturn.name}
                    labelOn={true}
                    type="text"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
                    disabled={true}
                  />

                  <div>
                    <SelectMenu
                      handleInputChange={() => {}}
                      name="order"
                      options={
                        creditReturn.order
                          ? [
                              {
                                value: creditReturn.order.id,
                                label:
                                  creditReturn.order.invoice_number ||
                                  `Order #${creditReturn.order.id}`,
                              },
                            ]
                          : []
                      }
                      value={
                        creditReturn.order
                          ? {
                              value: creditReturn.order.id,
                              label:
                                creditReturn.order.invoice_number ||
                                `Order #${creditReturn.order.id}`,
                            }
                          : null
                      }
                      title="Linked order"
                      showLabel={true}
                      disabled={!creditReturn.order}
                      placeholder="No order linked"
                    />
                    {creditReturn.order ? (
                      <Link
                        to={`/orders/${creditReturn.order.id}`}
                        className="text-sm font-semibold main-purple mt-1 inline-block"
                      >
                        View order
                      </Link>
                    ) : null}
                  </div>

                  {creditReturn.pdf_url ? (
                    <div>
                      <a
                        href={creditReturn.pdf_url}
                        target="_blank"
                        rel="noreferrer"
                        className="text-sm font-semibold main-purple"
                      >
                        View PDF
                      </a>
                    </div>
                  ) : null}
                  
                  {!isReadOnly && (
                    <div className="mt-3 flex flex-shrink-0 py-4 gap-2">
                      <ButtonDropdown
                        items={buttonOptions}
                        mainOption="Save"
                        mainAction={onSaveCr}
                      />
                      <button
                        onClick={() => {
                          askDeleteCr();
                        }}
                        className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
                <div className="card-custom p-3 mt-3">
                  <div className="flex justify-between">
                    <p className="text-sm text-gray-700 font-semibold">Notes</p>
                    {!isClosed && (
                      <button
                        onClick={() =>
                          setEmptyModelOpen({
                            childComponent: (
                              <OrderNotesModal
                                orderNote={creditReturn.notes}
                                confirmAction={(newNote) =>
                                  onUpdateCreditNote(newNote)
                                }
                                setOpen={setEmptyModelOpen}
                              />
                            ),
                            open: true,
                          })
                        }
                        className="text-sm font-semibold main-purple"
                      >
                        Edit
                      </button>
                    )}
                  </div>
                  <p className="text-sm text-gray-700 font-normal">
                    {creditReturn.notes ? creditReturn.notes : null}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderDetails)
);
